module.exports = __webpack_public_path__ + "img/download-charcoal.8e4053f7.svg";